export default __webpack_public_path__ + "static/media/cover-autofollow@3x.dcc899fc.png";